import i18n from 'i18next'
import { skipWeekends, workingDaysBetweenDates } from '../utils'
import startOfDay from 'date-fns/start_of_day'

const currentDate = startOfDay(new Date())
const currentMonth = currentDate.getMonth()
const currentYear = currentDate.getFullYear()

function getDate(date, monthOffset = 0) {
    return skipWeekends(
        new Date(currentYear, currentMonth + monthOffset, date),
        new Date(currentYear, currentMonth + monthOffset, date - 1)
    )
}

const state = {

    main: {
        tooltipType: 'selectCalendars'
    },

    currentTask: {
        id: null,
        startDate: null,
        endDate: null,
        duration: 0
    },

    tasks: [
        {
            id: 0,
            title: i18n.t('calendar:tasks.Task #1'),
            calendar: 1,
            startDate: getDate(21, -1),
            endDate: getDate(2),
            duration: 0
        },

        {
            id: 1,
            title: i18n.t('calendar:tasks.Task #2'),
            calendar: 2,
            startDate: getDate(1),
            endDate: getDate(3),
            duration: 0
        },

        {
            id: 2,
            title: i18n.t('calendar:tasks.Task #3'),
            calendar: 4,
            startDate: getDate(2),
            endDate: getDate(2),
            duration: 0
        },

        {
            id: 3,
            title: i18n.t('calendar:tasks.Task #4'),
            calendar: 3,
            startDate: getDate(6),
            endDate: getDate(8),
            duration: 0
        },

        {
            id: 4,
            title: i18n.t('calendar:tasks.Task #5'),
            calendar: 4,
            startDate: getDate(4),
            endDate: getDate(9),
            duration: 0,
        },

        {
            id: 5,
            title: i18n.t('calendar:tasks.Task #6'),
            calendar: 5,
            startDate: getDate(5),
            endDate: getDate(11),
            duration: 0
        },

        {
            id: 6,
            title: i18n.t('calendar:tasks.Task #7'),
            calendar: 1,
            startDate: getDate(10),
            endDate: getDate(13),
            duration: 0
        },

        {
            id: 7,
            title: i18n.t('calendar:tasks.Task #8'),
            calendar: 2,
            startDate: getDate(11),
            endDate: getDate(13),
            duration: 0
        },

        {
            id: 8,
            title: i18n.t('calendar:tasks.Task #9'),
            calendar: 3,
            startDate: getDate(13),
            endDate: getDate(17),
            duration: 0
        },

        {
            id: 9,
            title: i18n.t('calendar:tasks.Task #10'),
            calendar: 2,
            startDate: getDate(17),
            endDate: getDate(18),
            duration: 0
        },

        {
            id: 10,
            title: i18n.t('calendar:tasks.Task #11'),
            calendar: 1,
            startDate: getDate(19),
            endDate: getDate(5, 1),
            duration: 0
        },

        {
            id: 11,
            title: i18n.t('calendar:tasks.Task #12'),
            calendar: 3,
            startDate: getDate(20),
            endDate: getDate(13, 1),
            duration: 0
        }
    ],

    calendars: [
        {
            id: 1,
            name: i18n.t('calendar:calendars.Calendar 1'),
            color: '#ffcc80',
            enabled: false
        },

        {
            id: 2,
            name: i18n.t('calendar:calendars.Calendar 2'),
            color: '#9fa8da',
            enabled: false
        },

        {
            id: 3,
            name: i18n.t('calendar:calendars.Calendar 3'),
            color: '#80deea',
            enabled: false
        },

        {
            id: 4,
            name: i18n.t('calendar:calendars.Calendar 4'),
            color: '#f48fb1',
            enabled: false
        },

        {
            id: 5,
            name: i18n.t('calendar:calendars.Calendar 5'),
            color: '#80cbc4',
            enabled: false
        }
    ]
}

state.tasks.forEach(task => task.duration = workingDaysBetweenDates(task.startDate, task.endDate) || 1)

export default state
